<template>
  <div>
    <div class="row">
      <hr
      class="col-md-12 p-0 mt-5 mb-0 ml-5"
      style="background: rgba(53, 162, 229, 0.25);max-width: 98%;"
    />
      <div class="col-md-12 pt-0">
        <div class="row m-0 col-12 py-2 px-0 border-r-16">
          <div class="col-md-4 p-0">
            <span class="leatext_job_heading_by_new_home">Advertised Jobs</span>
          </div>
          <div class="col-md-8 p-0 pr-2 row m-0" style="align-items: center">
            <a
              href="/recruiter/jobs"
              class="text-end pr-0"
              style="
                font-size: 16px;
                color: rgb(3, 169, 244) !important;
                text-decoration: underline !important;
              "
            >
              View All Jobs
            </a>
          </div>
        </div>
        <div class="col-md-12 row p-0 m-0">
          <!-- /////////////////////////////////// -->
          <div data-app class="p-0">
            <div class="row mt-1 mx-0 new_list_st_by_ch">
              <div class="row m-0 col-12 p-0" style="height: fit-content">
                <!-- //////////////////////////////////start -->
                <!-- for fillter .filter((item) => item.user) -->
                <div
                  class="col-md-3 row m-0 mt-0 pt-0 pr-0"
                  v-for="(item, index) in data.filter(
                    (item) => item.archive == '0' && item.draft == '0'
                  )"
                  :key="index"
                  :class="index == 0 || index % 4 == 0 ? 'pl-0' : ''"
                  :style="index == 8 ? 'display:none' : ''"
                >
                  <div class="col-md-12 row m-0 border-r-16 p-4 bg-white">
                    <div class="col-md-12 p-0">
                      <h4
                        class="mb-0"
                        style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        "
                      >
                        {{ item.job_title }}
                      </h4>
                    </div>
                    <!-- <div class="col-md-12 p-0"> -->
                    <!-- <p
                        class=""
                        style="
                          width: fit-content;
                          border: 1px solid silver;
                          padding: 0px 2px 0px;
                          border-radius: 3px;
                          margin-right: 3px;
                          display: inline-block;
                          margin-bottom: 0 !important;
                          margin-top: 3px !important;
                        "
                        v-for="(_data, _index) in item.location_city"
                        :key="_index"
                        :class="_index > 4 ? 'd__none__' : ''"
                      >
                        {{ _data }}
                      </p> -->
                    <!-- </div> -->
                    <div class="col-md-12 p-0">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            mt-3
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Location_left.svg"
                            alt="..."
                            class="pr-4"
                          /><span class="tooltiptextch">Job Location</span>
                        </h4>
                        <p
                          v-if="item.location_city"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in item &&
                            item.location_city"
                            :key="_index"
                            style="display: inline-flex"
                          >
                            <span
                              v-if="
                                _index > 0 && _index < item.location_city.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item }}
                          </span>
                          <span v-if="item.location_city == ''">Not add</span>
                        </p>
                        <!-- </div> -->
                      </div>
                    </div>
                    <div class="col-md-12 p-0 py-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Money_left.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Per month salary</span>
                        </h4>
                        <span
                          v-if="
                            item.salary_min != NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                          >{{ item.salary_min }} - {{ item.salary_max }}</span
                        >
                        <span v-if="item.salary_market_competitive == 1">
                          Salary market competitive</span
                        >
                        <span v-if="item.salary_depends_on_exp == 1">
                          Salary depends on exp</span
                        >
                        <span
                          v-if="
                            item.salary_min == NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                        >
                          Not add</span
                        >
                      </div>
                    </div>
                    <div class="col-md-12 p-0 pb-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Due_date.svg"
                            alt="..."
                            class="pr-4"
                          /><span class="tooltiptextch">Expiry Date</span>
                        </h4>
                        <span>{{
                          moment(item.apply_by).format("DD MMM, YYYY")
                        }}</span>
                      </div>
                    </div>
                    <div class="_btn_gridddd_add_jon _btn_gridddd p-0 m-0">
                      <div class="p-0">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2 back_fill_job"
                        >
                         <a
                          target="blank"
                          :href="'/recruiter/job-applications?' + item.id"
                        >
                          <span class="v-btn__content text-white">View Applicants</span>
                        </a>
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2"
                        >
                          <div
                            @contextmenu="handler($event)"
                            @click="editButtonClick(item.id)"
                          >
                            <span class="v-btn__content">Edit</span>
                          </div>
                        </button>
                      </div>
                      <div
                        class="p-0"
                        style="position: relative"
                        @click="jobArchive(item)"
                      >
                        <button
                          type="button"
                          class="
                            new_details_job_dashbord_list2
                            tooltipch
                            archive_buton
                          "
                        >
                          <img
                            class="dashbord"
                            src="\images/job_page/archive.png"
                            alt=""
                            width="16"
                            height="16"
                          />
                          <span class="tooltiptextch gray">Archive Job</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-8 px-0 pt-4 m-0 info_short_leatesd">
                      <img
                        src="/images/job_application/InfoCircle.svg"
                        class=""
                      />
                      <span>
                        Added:
                        {{ moment(item.created_at).format("DD MMM, YYYY") }}
                      </span>
                    </div>
                    <div
                      class="col-4 px-0 pt-4 m-0 info_short_leatesd text-end"
                      v-if="!item.draft_behave"
                    >
                      <span
                        @click="deleteButtonClick(item)"
                        style="color: rgb(231 37 8); cursor: pointer"
                        >Delete job</span
                      >
                    </div>
                  </div>
                </div>
                <!-- <hr
                  class="col-md-12 p-0 mt-5"
                  style="background: rgba(53, 162, 229, 0.25)"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <v-form ref="form" v-if="createForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="city"
            :rules="nameRules"
            label="City name"
            required
          ></v-text-field>
          <b-form-select
            v-model="state_id"
            :options="statesOptions"
            size="sm"
            class="mt-3"
          ></b-form-select>
          <div style="margin-top: 5%">
            <v-btn
              class="
                btn btn-sm btn-success
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="createCity"
            >
              Save
            </v-btn>
            <v-btn
              style="margin-left: 6%"
              class="
                btn btn-sm btn-danger
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="cancel"
            >
              Cancel
            </v-btn>
          </div>
        </v-form>

        <v-form ref="form" v-if="updateForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="city"
            :rules="nameRules"
            label="City name"
            required
          ></v-text-field>
          <b-form-select
            v-model="state_id"
            :options="statesOptions"
            size="sm"
            class="mt-3"
          ></b-form-select>
          <div style="margin-top: 5%">
            <v-btn
              class="
                btn btn-sm btn-success
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="updateCity"
            >
              Update
            </v-btn>
            <v-btn
              style="margin-left: 6%"
              class="
                btn btn-sm btn-danger
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="cancel"
            >
              Cancel
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/core/api";
import Swal from "sweetalert2";
import moment from "moment";
import IndexService from "@/MainServices/IndexService.js";

export default {
  data() {
    return {
      search: "",
      cities: [],
      loading: true,
      success: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      createForm: false,
      updateForm: false,
      city: "",
      city_id: null,
      state_id: null,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      headers: [
        { text: "Job Title", value: "job_title" },
        { text: "City", value: "location_city" },
        { text: "SALARY RANGE", value: "salary_range" },
        // { text: "Job Type", value: "job_type" },
        // { text: "Job Function", value: "job_function" },
        { text: "Experience", value: "experience" },
        { text: "Education", value: "education" },
        // { text: "Gender", value: "gender" },
        { text: "No. of Vacancies", value: "no_of_vacancies" },
        { text: "Expiry date", value: "apply_by" },
        { text: "Action", value: "action" },
      ],
      data: [],
      detail1: null,
      alwyes: true,
    };
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.fetch();
    this.fetchStates();
    // IndexService.getCities().then((res) => {
    //     res.data.map((el) => {
    //       this.cities.push({
    //         id: el.id,
    //         value: el.city_name,
    //       });
    //     });
    //   });
  },
  methods: {
    handler: function (e) {
      //do stuff
      e.preventDefault();
    },
    moment: function (date) {
      return moment(date);
    },
    cancel() {
      this.createForm = false;
      this.updateForm = false;
      this.city = "";
      this.state_id = null;
    },
    createFormEnable() {
      this.$router.push({ name: "recruiter-job-create" });
    },
    editButtonClick(id) {
      // let cities = [];
      // this.cities.map((el) => {
      //   cities.push(el.value);
      // });
      // localStorage.setItem("city_local", this.cities);
      this.data.forEach((element) => {
        if (element.id == id) {
          localStorage.setItem("job_edit_obj", JSON.stringify(element));
          this.$router.push({ name: "recruiter-job-edit" });
        }
      });
    },
    // get_edit_link(id) {
    //   this.data.forEach((element) => {
    //     if (element.id == id) {
    //       localStorage.setItem("job_edit_obj", JSON.stringify(element));
    //       console.log(this.$router.push({ name: "recruiter-job-edit" })); //this.$router.push({ name: "recruiter-job-edit" });
    //     }
    //   });
    // },
    // viewJob(item) {
    //   let routeData = this.$router.resolve({
    //     path:
    //       "/jobs-careers/pakistan/" +
    //       item.location_city.map((v) => v.toLowerCase()).join("-") +
    //       "/" +
    //       item.job_title
    //         .toLowerCase()
    //         .replace(/ /g, "-")
    //         .replace(/[^\w-]+/g, "") +
    //       "/" +
    //       item.id,
    //     params: {
    //       search_text: this.search_text,
    //       selected_cities: [{ id: 1, value: item }],
    //     },
    //   });
    //   window.open(routeData.href, "_blank");
    // },
    job_link(item) {
      // console.log(item);
      let routeData = this.$router.resolve({
        path:
          "/jobs-careers/pakistan/" +
          item.location_city.map((v) => v.toLowerCase()).join("-") +
          "/" +
          item.job_title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "/" +
          item.id,
        // params: {
        //   search_text: this.search_text,
        //   selected_cities: [{ id: 1, value: item }],
        // },
      });
      return routeData.href;
    },
    fetch() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/jobs`)
        .then((res) => {
          this.data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchStates() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/states`)
        .then((res) => {
          res.data.forEach((element) => {
            this.statesOptions.push({
              value: element.id,
              text: element.state_name,
            });
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    createCity() {
      if ((this.city == "", this.state_id == null)) {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/cities`, {
          state_id: this.state_id,
          city_name: this.city,
        })
        .then((res) => {
          this.loading = false;
          this.success = true;
          this.city = "";
          Swal.fire({
            title: "",
            text: "City added",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    updateCity() {
      if ((this.city == "", this.state_id == null)) {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .put(`${API_URL}/cities/${this.city_id}`, {
          state_id: this.state_id,
          city_name: this.city,
        })
        .then((res) => {
          this.loading = false;
          this.success = true;
          (this.city = ""), (this.state_id = null);
          Swal.fire({
            title: "",
            text: "City updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
          this.cancel();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },

    deleteButtonClick(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-destroy/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Application has been deleted",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
          this.loading = false;
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        });
      this.detail1 = false;
      this.alwyes = true;
    },

    changeBlockStatus(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-block/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Job has been updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    changeStatus(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-status/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Job has been updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    jobArchive(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-archive/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Job has been updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    singleDetail1(item) {
      this.detail1 = item;
      this.alwyes = false;
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
  },
};
</script>
<style>
.container {
  max-width: none !important;
}
</style>